{
  "dropzoneLabel": "드롭 영역",
  "selectPlaceholder": "항목 선택",
  "tableResizer": "크기 조정기",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
